import * as Yup from 'yup';

import { Strings } from '@app/constants';
// ---------------UpdateProfileSchema-------------
export const UpdateProfileSchema = Yup.object()
  .shape({
    name: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.name))
      .max(36, 'Name must be at most 36 characters long'),
  })
  .required();

// ---------------SignUpSchema-------------
export const SignUpSchema = Yup.object()
  .shape({
    name: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
    email: Yup.string()
      .required(Strings.validation.fieldRequired(Strings.field.email))
      .email(Strings.validation.invalidEmail),
    id: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
  })
  .required();
